// Админка (порт 3000): npm start
// Мини-апа (порт 3001): npm run start:mini

if (process.env.REACT_APP_MINI_APP === 'true') {
  require('./indexMiniApp.js');
} else {
  require('./index.admin.js');
  module.exports.Context = require('./index.admin.js').Context;
}
